/* globals localStorage */
import axios from 'axios'
import config from '@/config.js'
import { store } from './store'

export default {
  login(email, pass, out_function) {
    out_function = arguments[arguments.length - 1]
    if (localStorage.token) {
      if (out_function) out_function(true)
      this.onChange(true)
      return
    }
    pretendRequest(email, pass, (res) => {
      if (res.authenticated) {
        localStorage.token = res.token
        if (out_function) out_function({status: true})
        this.onChange(true)
      } else {
        if (out_function) out_function({status: false, data: res.data})
        this.onChange(false)
      }
    })
  },

  getToken() {
    return localStorage.token
  },

  logout(out_function) {
    if (!!localStorage.token) {
      var data = new FormData()
      data.set('token', localStorage.token)
      axios({
        method: 'POST',
        url: config.API_HOST + '/user/logout',
        data: data
      })
        .then(function (response) {
          delete localStorage.token
          if (out_function) out_function(true)
          this.onChange(false)
        })
        .catch(function (error) {
          if (out_function) out_function(false)
        })
    }
  },

  loggedIn(name_page) {
    if (!!localStorage.token) {
      if (name_page == 'faucets-list' ||
        name_page == 'sensors-list' ||
        name_page == 'add-faucet' ||
        name_page == 'history' ||
        name_page == 'group-settings' ||
        name_page == 'notification-users' ||
        name_page == 'add-sensor'||
        name_page == 'sensor-settings'||
        name_page == 'faucet-settings') {
        store.commit('SET_LAYOUT', 'group-layout')
      }
      else store.commit('SET_LAYOUT', 'app-layout')
    }else {
      store.commit('SET_LAYOUT', 'login-layout')
    }
    return !!localStorage.token
  },

  onChange() {},

  checkUser(fail_check_user_function) {
    if (!!localStorage.token) {
        var data = new FormData()
        data.set('token', localStorage.token)
        axios({
            method: 'POST',
            url: config.API_HOST + '/user/check-user',
            data: data
        })
        .then(function (response) {})
        .catch(function (error) {
            if (error.response.status != 524) {
                delete localStorage.token
                fail_check_user_function()
            }
        })
    }
  }
}

function pretendRequest (email, password, out_function) {
  var login_data = new FormData()
  login_data.set('email', email)
  login_data.set('password', password)
  login_data.set('device_id', '')
  login_data.set('platform', '')
  axios({
    method: 'POST',
    url: config.API_HOST + '/user/login',
    data: login_data
  })
    .then(function (response) {
      out_function({
        token: response.data.token,
        authenticated: true,
        data: {}
      })
    })
    .catch(function (error) {
      var data = {}
      if (error.response) {
        data = error.response.data
      }
      out_function({
        authenticated: false,
        data: data
      })
    })
}



// WEBPACK FOOTER //
// ./src/auth.js